// extracted by mini-css-extract-plugin
module.exports = {"search":"_d14c3d8","searchForm":"_89bde1c","searchBarInput":"_5145f69","searchBarBtn":"_6ce30d8"};